import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const CampaignsWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default CampaignsWrapper